module.exports = __webpack_public_path__ + "static/eardrum-logo-8f88fcccfddc4856990f1d33f8696261.gif";